import * as React from 'react';
import { Bem } from '../../utils/css.js';
import '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import './Checkbox.scss.js';

const bem = Bem.create("vai-checkbox");
const Checkbox = React.forwardRef(function Checkbox2(props, ref) {
  const { htmlId, dataTa, label, ...inputProps } = props;
  const id = useId(htmlId, ["checkbox"]);
  const dataTaLabel = dataTa ? `${dataTa}--label` : void 0;
  return /* @__PURE__ */ React.createElement("label", {
    "data-ta": dataTaLabel,
    className: bem.block(inputProps.checked && "checked", inputProps.disabled && "disabled")
  }, /* @__PURE__ */ React.createElement("input", {
    id: id.toString(),
    "data-ta": dataTa,
    className: bem.element("checkbox")(inputProps.checked && "checked", inputProps.disabled && "disabled"),
    type: "checkbox",
    ref,
    ...inputProps
  }), label);
});
Checkbox.metaProperties = ["disabled"];

export { Checkbox };
